// import { useState, useEffect, useCallback } from 'react';

// const useApiUrls = () => {
//   const [apiUrls, setApiUrls] = useState([]);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchUrls = async () => {
//       try {
//         const response = await fetch('/url.json');
//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         const data = await response.json();
//         setApiUrls(data);
//       } catch (error) {
//         setError(error.message);
//         console.error('Failed to load API URLs:', error);
//       }
//     };

//     fetchUrls();
//   }, []);

//   const getUrlByOperation = useCallback((operationType) => {
//     const api = apiUrls.find(api => api.operationType === operationType);
//     if (!api) {
//       throw new Error(`No API found for operation type: ${operationType}`);
//     }
//     return api.url;
//   }, [apiUrls]);

//   return { getUrlByOperation, error };
// };

// export default useApiUrls;
import { useState, useEffect, useCallback } from 'react';

const useApiUrls = () => {
  const [apiUrls, setApiUrls] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUrls = async () => {
      try {
        const response = await fetch('/url.json'); // Ensure url.json is in the public folder
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setApiUrls(data);
      } catch (error) {
        setError(`Failed to load API URLs: ${error.message}`);
        console.error('Failed to load API URLs:', error);
      }
    };

    fetchUrls();
  }, []);

  const getUrlByOperation = useCallback((operationType) => {
    const api = apiUrls.find(api => api.operationType === operationType);
    if (!api) {
      console.error(`No API found for operation type: ${operationType}`);
      return null;
    }
    return api.url;
  }, [apiUrls]);

  return { getUrlByOperation, error };
};

export default useApiUrls;
